import React, { useEffect, useRef } from 'react';
import CompanyInfo from '../../components/CompanyInfo';

const HealthcareAndWellnessIndustry = () => {
 const canvasRef = useRef(null);
     const mousePosRef = useRef(null);
     const pointsRef = useRef([]);
     const animationRef = useRef(null);
   
     const maxDist = 200;
     const colour = "#FFFFFF";
   
     useEffect(() => {
       const canvas = canvasRef.current;
       const ctx = canvas.getContext("2d");
   
       // Point constructor
       class Point {
         constructor() {
           this.x = (Math.random() * (canvas.width + maxDist)) - (maxDist / 2);
           this.y = (Math.random() * (canvas.height + maxDist)) - (maxDist / 2);
           this.vx = (Math.random() * 2) - 1;
           this.vy = (Math.random() * 2) - 1;
           this.dia = Math.random() * 3 + 1;
         }
       }
   
       // Generate points
       const generatePoints = (amount) => {
         pointsRef.current = [];
         for (let i = 0; i < amount; i++) {
           pointsRef.current.push(new Point());
         }
       };
   
       // Draw function
       const draw = (obj) => {
         ctx.beginPath();
         ctx.fillStyle = colour;
         if (obj.dia) {
           ctx.arc(obj.x, obj.y, obj.dia, 0, 2 * Math.PI);
         } else {
           ctx.arc(obj.x, obj.y, 2, 0, 2 * Math.PI);
         }
         ctx.closePath();
         ctx.fill();
       };
   
       // Update function
       const update = (obj) => {
         obj.x += obj.vx;
         obj.y += obj.vy;
         if (obj.x > canvas.width + (maxDist / 2)) {
           obj.x = -(maxDist / 2);
         } else if (obj.x < -(maxDist / 2)) {
           obj.x = canvas.width + (maxDist / 2);
         }
         if (obj.y > canvas.height + (maxDist / 2)) {
           obj.y = -(maxDist / 2);
         } else if (obj.y < -(maxDist / 2)) {
           obj.y = canvas.height + (maxDist / 2);
         }
       };
   
       // Collision detection and line drawing
       const collision = (obj, dist) => {
         let temp;
         for (let i = 0; i < pointsRef.current.length; i++) {
           if (obj !== pointsRef.current[i]) {
             temp = Math.sqrt(
               Math.pow((obj.x - pointsRef.current[i].x), 2) + 
               Math.pow((obj.y - pointsRef.current[i].y), 2)
             );
             if (temp < dist) {
               ctx.beginPath();
               ctx.moveTo(obj.x, obj.y);
               ctx.strokeStyle = `rgba(255,255,255,${0.8 * Math.pow((dist - temp) / dist, 5)})`;
               ctx.moveTo(obj.x, obj.y);
               ctx.lineTo(pointsRef.current[i].x, pointsRef.current[i].y);
               ctx.closePath();
               ctx.stroke();
             }
           }
         }
       };
   
       // Main animation loop
       const pointFun = () => {
         ctx.clearRect(0, 0, canvas.width, canvas.height);
         if (mousePosRef.current) {
           collision(mousePosRef.current, maxDist * 2);
           draw(mousePosRef.current);
         }
         for (let i = 0; i < pointsRef.current.length; i++) {
           collision(pointsRef.current[i], maxDist);
           draw(pointsRef.current[i]);
           update(pointsRef.current[i]);
         }
       };
   
       // Resize canvas
       const resizeCanvas = () => {
         canvas.width = document.documentElement.clientWidth;
         canvas.height = window.innerHeight;
         generatePoints(170);
         pointFun();
       };
   
       // Mouse move handler
       const handleMouseMove = (evt) => {
         const rect = canvas.getBoundingClientRect();
         mousePosRef.current = {
           x: evt.clientX - rect.left,
           y: evt.clientY - rect.top
         };
       };
   
       // Initialize
       resizeCanvas();
       pointFun();
   
       // Start animation
       const interval = setInterval(pointFun, 16);
       animationRef.current = interval;
   
       // Event listeners
       window.addEventListener('resize', resizeCanvas);
       canvas.addEventListener('mousemove', handleMouseMove);
   
       // Cleanup
       return () => {
         clearInterval(interval);
         window.removeEventListener('resize', resizeCanvas);
         canvas.removeEventListener('mousemove', handleMouseMove);
       };
     }, []);
   
     return (
       <div style={{ 
         overflow: 'hidden',
         width: '100%',
         maxWidth: '100vw',
            paddingTop: '130px'
       }}>
         <div style={{ 
           margin: 0, 
           padding: 0, 
           overflow: 'hidden',
           width: '100%',
           height: '60vh',
           position: 'relative'
         }}>
           <canvas
             ref={canvasRef}
             id="canvas"
             style={{
               overflow: 'hidden',
               cursor: 'none',
               position: 'absolute',
               top: 0,
               left: 0,
               width: '100%',
               height: '100%',
               background: 'linear-gradient(to bottom, #306873, #52A7B0)'
             }}
           />
           <div style={{
             position: 'absolute',
             top: '50%',
             left: '50%',
             transform: 'translate(-50%, -50%)',
             textAlign: 'center',
             zIndex: 1
           }}>
            <h2 style={{
              color: '#ffffff',
              fontSize: '3rem',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> — Remote Staffing for Healthcare & Wellness
            </h2>
            <p style={{
              color: '#ffffff',
              fontSize: '1.25rem',
              marginTop: '1rem',
              textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
              maxWidth: '600px',
              margin: '1rem auto 0'
            }}>
              Support clinical and wellness operations with vetted remote specialists: medical coders, patient coordinators, telehealth support, and data analysts.
            </p>
           </div>
         </div>
         
    
       <section className="section_space bg-white">
         <div className="container">
           {/* Service Description */}
           <div className="row justify-content-center mb-5">
             <div className="col-lg-10">
               <div className="heading_block">
                 <h2 className="heading_text mb-4">Remote Clinical & Wellness Support</h2>
                 <p className="heading_description mb-4">
                   <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> provides remote teams skilled in healthcare operations — from medical record processing and coding to telehealth coordination and patient outreach. We help healthcare providers reduce administrative burden while maintaining compliance and patient privacy.
                 </p>
                 <p className="heading_description mb-4">
                   Our specialists include medical coders, clinical data analysts, telehealth schedulers, and QA reviewers who follow HIPAA-compliant workflows and integrate with your EHR and practice management systems.
                 </p>
                 <div className="row mt-5">
                   <div className="col-md-6">
                     <div className="iconbox_block layout_icon_left mb-4">
                       <div className="iconbox_content">
                         <h4 className="iconbox_title">Clinical Data Excellence</h4>
                         <p>Accurate medical record processing, coding, and data validation to support billing, analytics, and clinical decision-making.</p>
                       </div>
                     </div>
                   </div>
                   <div className="col-md-6">
                     <div className="iconbox_block layout_icon_left mb-4">
                       <div className="iconbox_content">
                         <h4 className="iconbox_title">Operational Optimization</h4>
                         <p>Process-driven specialists who optimize scheduling, referral handling, and care coordination to improve patient flow and outcomes.</p>
                       </div>
                     </div>
                   </div>
                   <div className="col-md-6">
                     <div className="iconbox_block layout_icon_left mb-4">
                       <div className="iconbox_content">
                         <h4 className="iconbox_title">Scalable Clinical Operations</h4>
                         <p>Flexible remote staffing for surge coverage, telehealth expansion, and administrative backlogs.</p>
                       </div>
                     </div>
                   </div>
                   <div className="col-md-6">
                     <div className="iconbox_block layout_icon_left mb-4">
                       <div className="iconbox_content">
                         <h4 className="iconbox_title">Quality Assurance</h4>
                         <p>Clinical QA, audit-ready documentation, and compliance checks to ensure accuracy and reduce risk.</p>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div className="mt-4">
                   <p className="heading_description">
                     <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> partners with clinics, telehealth providers, and wellness organizations to deliver secure, compliant remote staffing solutions. We adapt to your clinical workflows and regulatory requirements to protect patients and support care teams.
                   </p>
                 </div>
                 <div className="row mt-4">
                   <div className="col-md-6">
                     <ul className="icon_list unordered_list_block">
                       <li>
                         <i className="fas fa-check icon_list_icon"></i>
                        <span>Experienced in handling PHI and clinical records with secure, compliant workflows</span>
                      </li>
                      <li>
                        <i className="fas fa-check icon_list_icon"></i>
                        <span>Flexible coverage and on-call support for clinical operations</span>
                      </li>
                      <li>
                        <i className="fas fa-check icon_list_icon"></i>
                        <span>Customizable clinical workflows that integrate with your EHR</span>
                       </li>
                     </ul>
                   </div>
                   <div className="col-md-6">
                     <ul className="icon_list unordered_list_block">
                       <li>
                         <i className="fas fa-check icon_list_icon"></i>
                        <span>Regular clinical reporting, KPI dashboards, and audit trails</span>
                       </li>
                       <li>
                         <i className="fas fa-check icon_list_icon"></i>
                        <span>HIPAA-compliant data handling and strong access controls</span>
                       </li>
                       <li>
                         <i className="fas fa-check icon_list_icon"></i>
                        <span>Continuous improvement focused on patient satisfaction and operational efficiency</span>
                       </li>
                     </ul>
                   </div>
                 </div>
               </div>
             </div>
           </div>
           <CompanyInfo/>
           <div className="row mt-5">
             <div className="col-lg-12">
               <div className="heading_block mb-5">
                 <h2 className="heading_text">Benefits of <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> Healthcare & Wellness Talent</h2>
               </div>
             </div>
           </div>
           <div className="row g-4 mb-5">
             <div className="col-lg-4 d-flex">
               <div className="iconbox_block" style={{
                 border: '1px solid var(--bs-border-color)', 
                 borderRadius: 'var(--bs-border-radius)',
                 height: '100%',
                 padding: '40px 30px',
                 width: '100%',
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'flex-start'
               }}>
                 <div style={{
                   width: '80px',
                   height: '80px',
                   borderRadius: '50%',
                   backgroundColor: 'rgba(135, 206, 235, 0.2)',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   marginBottom: '25px'
                 }}>
                   <i className="fas fa-chart-line" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                 </div>
                 <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Operational Efficiency</h3>
                 <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Remote clinical assistants and administrative staff who reduce provider workload by handling coding, prior authorizations, and patient outreach.</p>
               </div>
             </div>
             <div className="col-lg-4 d-flex">
               <div className="iconbox_block" style={{
                 border: '1px solid var(--bs-border-color)', 
                 borderRadius: 'var(--bs-border-radius)',
                 height: '100%',
                 padding: '40px 30px',
                 width: '100%',
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'flex-start'
               }}>
                 <div style={{
                   width: '80px',
                   height: '80px',
                   borderRadius: '50%',
                   backgroundColor: 'rgba(135, 206, 235, 0.2)',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   marginBottom: '25px'
                 }}>
                   <i className="fas fa-shield-alt" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                 </div>
                 <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Clinical Quality & Compliance</h3>
                 <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Audit-ready QA processes and clinical reviewers who ensure documentation accuracy and coding compliance.</p>
               </div>
             </div>
             <div className="col-lg-4 d-flex">
               <div className="iconbox_block" style={{
                 border: '1px solid var(--bs-border-color)', 
                 borderRadius: 'var(--bs-border-radius)',
                 height: '100%',
                 padding: '40px 30px',
                 width: '100%',
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'flex-start'
               }}>
                 <div style={{
                   width: '80px',
                   height: '80px',
                   borderRadius: '50%',
                   backgroundColor: 'rgba(135, 206, 235, 0.2)',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   marginBottom: '25px'
                 }}>
                   <i className="fas fa-coins" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                 </div>
                 <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Cost Efficiency</h3>
                 <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Lower administrative overhead by scaling remote clinical and back-office staff according to demand while maintaining compliance.</p>
               </div>
             </div>
           </div>
         </div>
      </section>
     </div>
   );
 };

export default HealthcareAndWellnessIndustry;